<template>
  <layout-report :showFooter="false" :renderBackAndForthFooter="false">
    <thg-checkout-card
      :loading.sync="isLoading"
      @submit="submit"
      :userExists="userExists"
      :hint="hint"
      :dataProtectionHint="dataProtectionHint"
      :dataProtectionLabel="dataProtectionLabel"
    />
  </layout-report>
</template>

<script lang="ts">
import ThgCreateOverviewCard from "@/components/thg/ThgCreateOverviewCard.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { ConflictException } from "@/lib/exceptions/http";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component } from "vue-property-decorator";
import ThgCheckoutCard from "./ThgCheckoutCard.vue";
import { UserModule } from "@/store/modules/me-user.store";
import { MrfiktivPartnerViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

@Component({
  components: {
    LayoutReport,
    ThgCreateOverviewCard,
    ThgCheckoutCard
  }
})
export default class ThgCheckout extends ReportStepMixin implements IReportStep {
  header: IReportHeaderData = {
    title: "report.thgClosing.title",
    description: "report.thgClosing.description"
  };

  /**
   * TODO: set to thgclosing new
   */
  screen = ReportScreenEnum.thgCheckout;
  isDone = true;

  isLoading = false;

  userExists = false;
  userExistsText = "report.thgClosing.userAlreadyExists";

  get dataProtectionLabel(): string {
    return this.partner?.settings?.dataProtectionLabel || "";
  }

  get dataProtectionHint(): string {
    return this.partner?.settings?.dataProtectionHint || "";
  }

  get hint() {
    return "";
  }

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  get isConfirmed(): boolean {
    return ThgCreateModule.isConfirmed;
  }

  set isConfirmed(bool: boolean) {
    ThgCreateModule.setIsConfirmed(bool);
  }

  /**
   * Tries to submit a THG.
   * If submission is succesful
   */
  async submit() {
    // if (this.form.validate()) {
    this.isLoading = true;
    this.$log.debug("submit");

    try {
      if (!this.isAuthenticated) {
        await ThgCreateModule.submit();
      } else {
        await ThgCreateModule.submitIfAuthenticated();
      }

      this.$toast.success(this.$t("report.thgClosing.success"));
      this.$router.push({ name: "ThgSuccess" });
    } catch (error) {
      /**
       * Handle the case that a user already has an account.
       */
      if (error instanceof ConflictException) {
        if (this.isUserExisting(error.message)) {
          this.$toast.error(this.$t(this.userExistsText));
          this.userExists = true;
          return;
        } else {
          this.$toast.error(this.$t("report.thgClosing.error"));
        }
      } else {
        this.$log.error(error);
        this.$toast.error(this.$t("report.thgClosing.error"));
      }

      this.isConfirmed = false;
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * Checks wether the error messages indicates a user exists.
   *
   * @param message the exception message received
   * @returns if user exists
   */
  isUserExisting(message: string) {
    return [
      "An account with the given email already exists.",
      "Email-Address already used.",
      "UsernameExistsError"
    ].includes(message);
  }

  get partnerName(): string {
    return ReportModule?.partner.companyName;
  }

  get partner(): MrfiktivPartnerViewModelGen | null {
    return ReportModule?.partner;
  }
}
</script>

<style scoped>
.text {
  color: rgba(0, 0, 0, 0.6);
}
</style>
